<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-treeview
          :items="[
            {
              name: 'Example format in archive',
              children: [
                {
                  name: 'video_8233_dg_1297_num3_000048_1652711729050.mp4 (slide)',
                  file: 'mdi-file-video'
                },
                {
                  name: 'VIE_9024_Ave_Maria_Karlskirche_3.mp4 (video)',
                  file: 'mdi-file-video'
                },
                {
                  name: 'poi1_Empire_State_Building_video15_ambrel43_priority2.mp4 (amb video)',
                  file: 'mdi-file-video'
                },
              ]
            }
          ]"
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
            <v-icon v-else>
              {{ item.file }}
            </v-icon>
          </template>
        </v-treeview>
        <v-row
          align="center"
          justify="space-between"
        >
          <v-col cols="2" v-if="displayType">
            <v-select
              label="Type"
              v-model="videosImport.type"
              :items="types"
            />
          </v-col>
          <v-col cols="3" v-if="displayType">
            <v-select
              label="Video source"
              v-model="videosImport.videoSource"
              :items="videoSourceList"
              item-text="name"
              item-value="id"
            />
          </v-col>
          <v-col>
            <v-file-input
              v-model="videosImport.file"
              accept=".zip"
              show-size
              label="Click here to import videos"
            />
          </v-col>
          <v-col>
            <v-text-field
              prefix="OR"
              v-model="videosImport.folderName"
              label="Google drive unique folder name"
            />
          </v-col>
        </v-row>
        <v-progress-linear
          v-show="videosImport.loading"
          v-model="videosImport.progress"
          height="25"
        >
          <strong>{{ Math.ceil(videosImport.progress) }}%</strong>
        </v-progress-linear>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="uploadArchive"
        :loading="videosImport.loading"
        :disabled="!videosImport.file && !videosImport.folderName"
        color="blue darken-1"
      >
        Import
      </v-btn>
    </v-card-actions>

    <v-container>
      <v-row>
        <v-col class="text-h3">Video list</v-col>
        <v-col class="text-right">
          <v-btn @click="getVideosList" small>
            <v-icon small>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-h3">
          <v-data-table
            :headers="headers"
            :items="videosList"
            :item-class="rowClass"
            disable-sort
          >
            <template v-slot:item.video_type="{ item }">
              {{ item.video_type ? item.video_type : 'video' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.status === 'fail_upload'"
                @click="reloadRecord(item.id)"
                fab dark x-small color="blue"
                class="mx-1">
                <v-icon>mdi-reload</v-icon>
              </v-btn>
              <v-btn
                @click="deleteRecord(item.id)"
                fab dark x-small color="red"
                class="mx-1">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImportVideosComponent',
  props: {
    displayType: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    videosImport: {
      show: false,
      type: 'video',
      videoSource: 1,
      file: null,
      folderName: null,
      loading: false,
      progress: 0,
    },
    videoSourceList: [],
    types: [
      'slide',
      'video',
    ],
    videosList: [],
    logShow: false,
    headers: [
      {
        text: 'archive',
        value: 'archive',
      },
      {
        text: 'index',
        value: 'index',
      },
      {
        text: 'video_file',
        value: 'video_file',
      },
      {
        text: 'video_type',
        value: 'video_type',
      },
      {
        text: 'poi_id',
        value: 'poi_id',
      },
      {
        text: 'video_id',
        value: 'video_id',
      },
      {
        text: 'user',
        value: 'user.name',
      },
      {
        text: 'created_at',
        value: 'created_at',
      },
      {
        text: 'status',
        value: 'status',
      },
      {
        text: 'error',
        value: 'error',
      },
      {
        text: 'actions',
        value: 'actions',
      },
    ],
  }),

  created() {
    this.getVideosList();
    this.getVideoSources();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    getVideosList() {
      this.$requestHelpers
        .post('api/admin/video/importVideos',
          {
            stage: 'videosList',
          })
        .then((response) => {
          this.videosList = response.data.result;
        });
    },

    getVideoSources() {
      this.$requestHelpers
        .get('api/admin/allVideoSources')
        .then((response) => {
          this.videoSourceList = response.data;
        });
    },

    uploadArchive() {
      if (this.videosImport.file) {
        this.videosImport.loading = true;

        this.$requestHelpers
          .post('api/admin/video/importVideos',
            {
              stage: 'check',
              fileSize: this.videosImport.file.size,
              fileName: this.videosImport.file.name,
            })
          .then((response) => {
            if (response.data.success) {
              this.chunk(this.videosImport.file, (file) => {
                const formData = new FormData();
                formData.append('zip_file', file);
                formData.append('video_source', this.videosImport.videoSource);
                formData.append('type', this.videosImport.type);
                formData.append('stage', 'uploadFile');

                this.$requestHelpers
                  .post('api/admin/video/importVideos',
                    formData)
                  .then((error) => {
                    this.videosImport.file = null;
                    if (error.data?.result.length) {
                      this.showError(error.data.result);
                    }
                    this.getVideosList();
                  })
                  .finally(() => {
                    this.videosImport.loading = false;
                  });
              });
            } else {
              this.videosImport.loading = false;
            }
          })
          .catch(() => {
            this.videosImport.loading = false;
          });
      } else if (this.videosImport.folderName) {
        this.$requestHelpers
          .post('api/admin/video/importVideos',
            {
              folderName: this.videosImport.folderName,
              video_source: this.videosImport.videoSource,
              type: this.videosImport.type,
              stage: 'uploadFile',
            })
          .then((error) => {
            this.videosImport.file = null;
            this.videosImport.folderName = null;
            if (error.data?.result.length) {
              this.showError(error.data.result);
            }
            this.getVideosList();
          })
          .finally(() => {
            this.videosImport.loading = false;
          });
      }
    },

    deleteRecord(id) {
      this.$confirm('Are you sure you wand delete?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post('api/admin/video/importVideos',
            {
              import_video_id: id,
              stage: 'delete',
            })
          .then((response) => {
            if (response.data.success) {
              this.videosList.splice(this.videosList.findIndex((e) => e.id === id), 1);
            }
          });
      });
    },

    reloadRecord(id) {
      this.$confirm('Are you sure you want try again? Old video will be destroyed!').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post('api/admin/video/importVideos',
            {
              import_video_id: id,
              stage: 'reload',
            })
          .then(() => {
            this.getVideosList();
          });
      });
    },

    percentProgress(done, total) {
      if (!total) {
        return 0;
      }

      const progress = Math.round((done / total) * 100);
      return parseInt(progress, 10);
    },

    rowClass(item) {
      let rowClass = '';
      switch (item.status) {
        case 'fail':
          rowClass = 'red lighten-2';
          break;
        case 'fail_upload':
          rowClass = 'red lighten-1';
          break;
        case 'done':
          rowClass = 'green lighten-2';
          break;
        default:
      }
      return rowClass;
    },

    showError(message = 'error') {
      this.setSnack({
        color: 'red',
        text: message,
      });
    },

    chunk(file, onSuccess, onError) {
      const chunkNumber = 0;
      const identifier = `${file.size}-${file.name.replace('.', '')}`;

      this.chunkUploader(file, {
        identifier,
        chunkNumber,
        onError,
        onSuccess,
      });
    },

    chunkUploader(file, options) {
      const chunkSize = 1024 * 1024 * 100;

      const blockCount = Math.ceil(file.size / chunkSize);
      const start = options.chunkNumber * chunkSize;
      const end = Math.min(file.size, start + chunkSize);

      let currentChunkSize = chunkSize;
      if (options.chunkNumber + 1 === blockCount) {
        currentChunkSize = file.size - start;
      }

      const params = new FormData();
      params.append('stage', 'uploadArchive');
      params.append('resumableChunkNumber', options.chunkNumber + 1);
      params.append('resumableChunkSize', currentChunkSize);
      params.append('resumableCurrentChunkSize', currentChunkSize);
      params.append('resumableTotalSize', file.size);
      params.append('resumableType', file.type);
      params.append('resumableIdentifier', options.identifier);
      params.append('resumableFilename', file.name);
      params.append('resumableRelativePath', file.name);
      params.append('resumableTotalChunks', blockCount);
      params.append('file', file.slice(start, end), file.name);

      this.$requestHelpers
        .post('api/admin/video/importVideos', params, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          },
        })
        .then((res) => {
          this.videosImport.progress = this.percentProgress(end, file.size);

          if (end === file.size) {
            // eslint-disable-next-line no-unused-expressions
            options.onSuccess && options.onSuccess(res.data.result);
          } else {
            // eslint-disable-next-line no-param-reassign
            options.chunkNumber += 1;
            this.chunkUploader(file, options);
          }
        })
        .catch(() => {
          this.videosImport.loading = false;
        });
    },
  },

};
</script>
